<template>
  <div class="header"  >
    <div class="head">
      <div class="logo"><img src="../../src/assets/img/logo.png" alt=""></div>
      <nav class="header_nav">
        <li><router-link to="/">首页</router-link></li>
        <li>
          <router-link to="/NetworkPublishing">网络出版</router-link>
          <div class="pop-up">
              <div class="pop-up-content">
                  <div class="recommended"><img src="../../src/assets/img/NetworkPublishing1.png" alt=""></div>
                <div class="second_level">
                  <h3>网络出版</h3>
                  <ul class="second_level_list">
                    <li>
                      <div class="second_level_icon">
                        <img src="../../src/assets/img/network1.png" alt="">
                      </div>
                       <div class="">
                         <h6>互联网文学</h6>
                         <p>副文本副文本副文本副文本副文本副文本</p>
                       </div>
                    </li>
                    <li>
                      <div class="second_level_icon">
                        <img src="../../src/assets/img/hts.png" alt="">
                      </div>
                       <div class="">
                         <h6>互联网图书</h6>
                         <p>副文本副文本副文本副文本副文本副文本</p>
                       </div>
                    </li>
                    <li>
                      <div class="second_level_icon">
                        <img src="../../src/assets/img/network2.png" alt="">
                      </div>
                      <div class="">
                        <h6>图书、电子出版</h6>
                        <p>副文本副文本副文本副文本副文本副文本</p>
                      </div>
                    </li>
                    <li>
                      <div class="second_level_icon">
                        <img src="../../src/assets/img/network3.png" alt="">
                      </div>
                      <div class="">
                        <h6>手机出版物</h6>
                        <p>副文本副文本副文本副文本副文本副文本</p>
                      </div>
                    </li>
                    <li>
                      <div class="second_level_icon">
                        <img src="../../src/assets/img/network4.png" alt="">
                      </div>
                      <div class="">
                        <h6>杂志、教育、学术</h6>
                        <p>副文本副文本副文本副文本副文本副文本</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
          </div>
        </li>
        <li><router-link to="/Music_art">电子音像</router-link>
          <div class="pop-up">
            <div class="pop-up-content">
              <div class="recommended"><img src="../../src/assets/img/header2.png" alt=""></div>
              <div class="second_level">
                <h3>音乐艺术</h3>
                <ul class="second_level_list">
                  <li>
                    <div class="second_level_icon">
                      <img src="../../src/assets/img/yxcbw.png" alt="">
                    </div>
                    <div class="">
                      <h6>互联网音像出版物</h6>
                      <p>副文本副文本副文本</p>
                    </div>
                  </li>
                  <li>
                    <div class="second_level_icon">
                      <img src="../../src/assets/img/yxcb.png" alt="">
                    </div>
                    <div class="">
                      <h6>音像出版物</h6>
                      <p>副文本副文本副文本副文本副文本副文本</p>
                    </div>
                  </li>

                </ul>
              </div>
            </div>
          </div>
        </li>
        <li><router-link to="/BlockChain">区块链+</router-link>
          <div class="pop-up">
            <div class="pop-up-content">
              <div class="recommended"><img src="../../src/assets/img/header3.png" alt=""></div>
              <div class="second_level">
                <h3>区块链+</h3>
                <ul class="second_level_list">
                  <li>
                    <div class="second_level_icon">
                      <img src="../../src/assets/img/dcl.png" alt="">
                    </div>
                    <div class="">
                      <h6>底层链</h6>
                      <p>副文本副文本副文本副文本副文本副文本</p>
                    </div>
                  </li>
                  <li>
                    <div class="second_level_icon">
                      <img src="../../src/assets/img/ggfw.png" alt="">
                    </div>
                    <div class="">
                      <h6>公共服务</h6>
                      <p>副文本副文本副文本副文本副文本副文本</p>
                    </div>
                  </li>
                  <li>
                    <div class="second_level_icon">
                      <img src="../../src/assets/img/fxpt.png" alt="">
                    </div>
                    <div class="">
                      <h6>发行平台</h6>
                      <p>副文本副文本副文本副文本副文本副文本</p>
                    </div>
                  </li>
                  <li>
                    <div class="second_level_icon">
                      <img src="../../src/assets/img/yylz.png" alt="">
                    </div>
                    <div class="">
                      <h6>应用与流转</h6>
                      <p>副文本副文本副文本副文本副文本副文本</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
        <li><router-link to="/Game">游戏+</router-link>
          <div class="pop-up">
            <div class="pop-up-content">
              <div class="recommended"><img src="../../src/assets/img/header4.png" alt=""></div>
              <div class="second_level">
                <h3>游戏+</h3>
                <ul class="second_level_list">
                  <li>
                    <div class="second_level_icon">
                      <img src="../../src/assets/img/yxcb_h.png" alt="">
                    </div>
                    <div class="">
                      <h6>游戏出版</h6>
                      <p>副文本副文本副文本副文本副文本副文本</p>
                    </div>
                  </li>
                  <li>
                    <div class="second_level_icon">
                      <img src="../../src/assets/img/zbfx1.png" alt="">
                    </div>
                    <div class="">
                      <h6>动漫产品</h6>
                      <p>副文本副文本副文本副文本副文本副文本</p>
                    </div>
                  </li>
                  <li>
                    <div class="second_level_icon">
                      <img src="../../src/assets/img/zhhd_h.png" alt="">
                    </div>
                    <div class="">
                      <h6>展会活动</h6>
                      <p>副文本副文本副文本副文本副文本副文本</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
        <li><router-link to="/AboutUs">关于我们</router-link></li>
        <template v-if="user">
          <li class="user-menu" >
           
			<div class="user-trigger" @mouseenter="showMenu=true" @mouseleave="showMenu=false">
              <span class="user-name">{{ displayName }}</span>		
					
            </div>
			<button class="recharge-btn" @click="onRecharge">充值</button>
			<button class="refund-btn" @click="onRefund">退款</button>
            <div class="user-dropdown" v-show="showMenu">
              <button class="logout-btn" @click="onLogout">退出登录</button>
              
            </div>
          </li>
        </template>
        <template v-else>
          <li><router-link to="/Login">登录</router-link></li>
          <li><router-link to="/Register">注册</router-link></li>
        </template>
      </nav>
      <div class=""><img src="" alt=""></div>
    </div>
  </div> 
</template>
<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      user: null,
      showMenu: false,
    }
  },
  computed: {
    displayName() {
      const name = this.user?.name || this.user?.nickname || ''
      const phone = this.user?.phone || ''
      const result = name || phone
      console.log('displayName计算:', { user: this.user, name, phone, result }) // 添加调试日志
      return result
    },
    displayInitial() {
      const n = this.displayName
      return n ? n.substring(0,1).toUpperCase() : 'U'
    }
  },
  mounted(){
    this.refreshUser()
    window.addEventListener('auth-changed', this.refreshUser)
  },
  beforeUnmount(){
    window.removeEventListener('auth-changed', this.refreshUser)
  },
  methods:{
    refreshUser(){
      const token = localStorage.getItem('token')
      const userName = localStorage.getItem('user_name')
      
      if (!token) {
        this.user = null
        return
      }
      
      // 直接使用localStorage中的用户姓名
      if (userName) {
        this.user = { name: userName }
        console.log('从localStorage获取用户姓名:', userName) // 添加调试日志
      } else {
        this.user = null
        console.log('未找到用户姓名') // 添加调试日志
      }
    },
    onLogout(){
      localStorage.removeItem('token')
      localStorage.removeItem('user_name')
      localStorage.removeItem('user_info')
      localStorage.removeItem('login_result')
      this.user = null
      window.dispatchEvent(new Event('auth-changed'))
      this.$router.push('/Login')
    },
    onRecharge(){
      // 充值功能
      console.log('充值功能')
      // 这里可以跳转到充值页面或打开充值弹框
      this.$router.push('/Recharge')
    },
    onRefund(){
      // 退款功能
      console.log('退款功能')
      // 这里可以跳转到退款页面或打开退款弹框
      this.$router.push('/Refund')
    }
  },
};
</script>
<style scoped>
@import '../../src/assets/css/header.css';
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body,html{
	font-family: "Microsoft YaHei", Arial, sans-serif;
}
.user-menu { position: relative; }
.user-trigger { display: inline-flex; align-items: center; cursor: pointer; }
.user-name { color: #fff; font-size: 14px; font-weight: 500; }
.user-dropdown {
  width: 80px;
  position: absolute; 
  top: 70px; 
  right: 50px; 
  background: #fff; 
  border: 1px solid rgba(0,0,0,.08); 
  border-radius: 6px; 
  padding: 8px; 
  box-shadow: 0 6px 20px rgba(0,0,0,.08);
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.logout-btn  { 
  background: none; 
  border: none; 
  padding: 6px 12px; 
  cursor: pointer; 
  font-size: 12px;
  text-align: center;
  border-radius: 4px;
  transition: background-color 0.2s;
}
.recharge-btn, .refund-btn { 
	color: #fff;
  background: none; 
  border: none; 
  padding: 6px 12px; 
  cursor: pointer; 
  font-size: 12px;
  text-align: center;
  border-radius: 4px;
  transition: background-color 0.2s;
}
.logout-btn:hover, .recharge-btn:hover, .refund-btn:hover {
   
}
</style>
